module.exports = __webpack_public_path__ + "img/product-shot_02.dbb8da15.jpg";